/* @flow */

import * as React from 'react';
import Select, {Creatable, AsyncCreatable} from 'react-select';
import {SelectMenu, type SelectMenuOption} from '../select-menu';
import {SelectPickerBase} from './select-picker-base';

type Props = {
    name: string,
    label: string,
    onChange: Function,
    value: any,
    valueKey: string,
    labelKey: string,

    // This signifies an Async, multi-select
    loadOptions?: (query: string) => Promise<Object[]>,

    // Is this an array of objects, or just a single-select?
    multi?: boolean,

    // These are only required if loadOptions is not present
    options?: Object[],
    getRef?: (?Select) => any,

    autoBlur?: boolean,

    secondaryNewOptions: SelectMenuOption[],
    onCloseSelectMenu: () => any,
    formatCreateLabel: (label: string) => any,
    component: Class<Creatable> | Class<AsyncCreatable>,
};

export class SelectPickerCreatable extends React.PureComponent<Props> {
    containerRef: ?HTMLElement;
    reactSelect: ?Select;

    UNSAFE_componentWillReceiveProps(nextProps: Props) {
        if (
            !this.props.secondaryNewOptions.length &&
            nextProps.secondaryNewOptions.length &&
            this.reactSelect
        ) {
            // When we display the secondary creation menu,
            // ensure to blur the underlying select
            this.reactSelect.blur();
        }
    }

    render() {
        return (
            <div
                ref={(node) => {
                    this.containerRef = node;
                }}
            >
                <SelectPickerBase {...this.props} getRef={this.handleRefAssignment} />
                {/* This menu is only shown when selecting a secondary
                option when creating a new entity. For example, when
                a user wants to create an activity participant, they
                need to select Person vs. Company */}
                {this.props.secondaryNewOptions.length ? (
                    <SelectMenu
                        anchor={this.containerRef}
                        location='custom'
                        options={this.props.secondaryNewOptions}
                        onClose={this.props.onCloseSelectMenu}
                    />
                ) : (
                    undefined
                )}
            </div>
        );
    }

    handleRefAssignment = (node: ?Select) => {
        this.reactSelect = node;

        if (this.props.getRef) {
            this.props.getRef(node);
        }
    };
}
